// extracted by mini-css-extract-plugin
export default {"root":"BotHeadSpinWithMessage_root__Gf8tZ","message":"BotHeadSpinWithMessage_message__+f9vH"};